export const LEAD_FORM_ID = 'lead-form'

/** Smooth-scrolls to the lead form, honoring reduced-motion preferences. */
export function scrollToLeadForm(): void {
  const el = document.getElementById(LEAD_FORM_ID)
  if (!el) return
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  el.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' })
}
